
import { AxiosError } from "axios";
import { Ref, ref } from "vue";

import { Shinsei } from "@/types/Shinsei";
import { FormUtil } from "@/utils/FormUtil";
import { ShinseiService } from "@/service/ShinseiService";
import { DialogService } from "@/service/DialogService";
import { useForm } from '@/composable/form/form';

export function useCreate() {
  const { removeAllError } = useForm()
  const isCreating = ref(false);
  const srv = new ShinseiService();

  const create = (form: Ref<Shinsei>): Promise<Shinsei | null> => {
    isCreating.value = true;
    DialogService.nowloading('申請登録中...');

    let returnval: Shinsei | null;

    return srv.create(form.value).then(res => {
      if (res !== null) {
        DialogService.info({
          text: `申請を登録しました`
        }, true);
      } else {
        DialogService.error({
          text: '予期せぬ事態が発生し登録に失敗しました'
        }, true);
      }
      isCreating.value = false;
      returnval = res;
    }).catch(e => {
      // 一回全部消す
      removeAllError(form.value)
      const val = Object.entries(form.value).find((key, data) => { 
        if(key[0] === form.value.shinsei_type_str){
          return data
        }
      })
      removeAllError(val?.[1])

      const err = e as AxiosError<any>;
      FormUtil.setLaravelError(form.value, err);
      returnval = null;
    }).then(() => {
      /* --- finaly処理 --- */
      // 登録中フラグを解除
      isCreating.value = false;
      return returnval;
    })
  }

  const createForDakokuSyuusei = async (form: Ref<Shinsei>): Promise<Shinsei | null> => {
    isCreating.value = true
    let returnval: Shinsei | null;
    return await srv.create(form.value).then(res => {
      if (res == null) {
        DialogService.error({
          text: '予期せぬ事態が発生し登録に失敗しました'
        }, true);
      }else{
        returnval = res
      }
      isCreating.value = false;
    }).catch(e => {
      removeAllError(form.value)
      const err = e as AxiosError<any>;
      FormUtil.setLaravelError(form.value, err);
      returnval = null;
    }).then(() => {
      /* --- finaly処理 --- */
      // 登録中フラグを解除
      isCreating.value = false;
      return returnval;
    })
  };

  return {
    isCreating,
    create,
    createForDakokuSyuusei,
  }
}
